<!--
  Action dialog "Umbuchung" (reserve <-> provision transfer).

  IMPORTANT (Design-Gate B-9): NO form HTML in this file. Direction, amount, valuta date, and
  reason are rendered by the transient form widget built from the MvsFormDto in the TS — repo
  precedent wf-process-start.component.html. Only dialog frame, balance preview, and action
  button live here.
-->
<p-dialog
        header="Umbuchung"
        [visible]="visible"
        (visibleChange)="handleVisibleChange($event)"
        (onShow)="handleShow()"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{width: '46rem'}"
        [breakpoints]="{'960px': '90vw'}"
        styleClass="cp-provision-agent-transfer-dialog">

    @if (busy && !formWidget) {

        <p-skeleton height="16rem"></p-skeleton>

    } @else if (formWidget) {

        <!-- Capture: metadata-driven form widget -->
        <mvs-widget
                [widgetData]="formWidget"
                (onGenericEvent)="handleGenericEvent($event)">
        </mvs-widget>

        <!-- Balance preview of both accounts -->
        <div class="surface-100 border-round p-3 mt-3">

            <div class="font-semibold mb-2">Saldo-Vorschau</div>

            @if (previewProvisionAfter == null || previewReserveAfter == null) {

                <span class="text-color-secondary text-sm">
                    Richtung und Betrag wählen, um die Wirkung auf beide Konten zu sehen.
                </span>

            } @else {

                <div class="grid">

                    <div class="col-12 md:col-6">
                        <div class="surface-card border-round p-3 h-full">
                            <div class="text-color-secondary text-sm mb-2">Provisionskonto</div>
                            <div class="flex align-items-center gap-2">
                                <span class="text-color-secondary">
                                    {{ balanceDto?.provisionBalance | currency:'EUR':'symbol':'1.2-2' }}
                                </span>
                                <i class="fa-regular fa-arrow-right text-color-secondary"></i>
                                <span class="text-xl font-semibold">
                                    {{ previewProvisionAfter | currency:'EUR':'symbol':'1.2-2' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6">
                        <div class="surface-card border-round p-3 h-full">
                            <div class="text-color-secondary text-sm mb-2">Rücklagenkonto</div>
                            <div class="flex align-items-center gap-2">
                                <span class="text-color-secondary">
                                    {{ balanceDto?.reserveBalance | currency:'EUR':'symbol':'1.2-2' }}
                                </span>
                                <i class="fa-regular fa-arrow-right text-color-secondary"></i>
                                <span class="text-xl font-semibold"
                                      [class.text-red-500]="previewCausesUnderfunding">
                                    {{ previewReserveAfter | currency:'EUR':'symbol':'1.2-2' }}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>

                @if (previewCausesUnderfunding) {
                    <p-message severity="warn" styleClass="w-full mt-3">
                        <span>
                            Diese Umbuchung führt das Rücklagenkonto ins Minus und bremst damit die
                            Auszahlung an den Berater.
                        </span>
                    </p-message>
                }

            }

        </div>

        @if (failureMessage) {
            <p-message severity="error" [text]="failureMessage" styleClass="w-full mt-3"></p-message>
        }

    }

    <ng-template pTemplate="footer">
        <p-button
                label="Abbrechen"
                icon="fa-regular fa-xmark"
                severity="secondary"
                [text]="true"
                (onClick)="handleClose()">
        </p-button>

        <p-button
                label="Umbuchen"
                icon="fa-regular fa-check"
                severity="primary"
                [loading]="busy"
                [disabled]="!submittable"
                (onClick)="handleTransfer()">
        </p-button>
    </ng-template>

</p-dialog>
